import React from "react";
import HomepageBrandValue, {
    HomepageBrandValueProps,
} from "web/react/components/homepage-brand-value/homepage-brand-value";
import TopProducts, { TopProductsProps } from "web/react/components/top-products/top-products";
import TopLysts, { TopLystsProps } from "web/react/components/top-lysts/top-lysts";
import HomepageBreakoutBrands, {
    HomepageBreakoutBrandsProps,
} from "web/react/components/homepage-breakout-brands/homepage-breakout-brands";
import HomepageCategoryLinks, {
    GenericType,
} from "web/react/components/homepage-category-links/homepage-category-links";
import HomepageMostWantedRail, {
    HomepageMostWantedRailsProps,
} from "web/react/components/homepage-most-wanted-rail/homepage-most-wanted-rail";
import PromoBanner, { PromoBannerProps } from "web/react/components/promo-banner/promo-banner";
import styles from "./homepage-layout.css";

interface HomepageLayoutProps {
    layoutData: {
        homepage_popular_products: TopProductsProps;
        homepage_brand_values: HomepageBrandValueProps;
        homepage_featured_banners: TopLystsProps;
        homepage_breakout_brands: HomepageBreakoutBrandsProps;
        homepage_trends: HomepageMostWantedRailsProps;
        homepage_generic_types: GenericType[];
        homepage_promo_banner: PromoBannerProps;
    };
}

export function HomepageLayout({
    layoutData: {
        homepage_popular_products: popularProducts,
        homepage_brand_values: brandValues,
        homepage_featured_banners: featuredBanners,
        homepage_breakout_brands: breakoutBrands,
        homepage_trends: trends,
        homepage_generic_types: genericTypes,
        homepage_promo_banner: promoBanner,
    },
}: HomepageLayoutProps): JSX.Element {
    return (
        <div className={styles.homepageLayout}>
            {promoBanner && <PromoBanner {...promoBanner} />}
            {popularProducts && (
                <TopProducts title={popularProducts.title} products={popularProducts.products} />
            )}
            {featuredBanners && <TopLysts {...featuredBanners} />}
            {breakoutBrands && <HomepageBreakoutBrands {...breakoutBrands} />}
            {brandValues && <HomepageBrandValue {...brandValues} />}
            {trends && <HomepageMostWantedRail {...trends} />}
            {genericTypes && <HomepageCategoryLinks genericTypes={genericTypes} />}
        </div>
    );
}

export default HomepageLayout;
